/**
 * @generated SignedSource<<b1b43ab6cedfca082f97f2d61a595cf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type sharedNotificationsMutation$variables = {
  deviceIdentifier: string;
  devicePlatform: string;
  notificationToken?: string | null;
};
export type sharedNotificationsMutation$data = {
  readonly userUpdateDeviceInfo: {
    readonly user: {
      readonly id: string;
    };
  } | null;
};
export type sharedNotificationsMutation = {
  response: sharedNotificationsMutation$data;
  variables: sharedNotificationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceIdentifier"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "devicePlatform"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notificationToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "deviceIdentifier",
        "variableName": "deviceIdentifier"
      },
      {
        "kind": "Variable",
        "name": "devicePlatform",
        "variableName": "devicePlatform"
      },
      {
        "kind": "Variable",
        "name": "notificationToken",
        "variableName": "notificationToken"
      }
    ],
    "concreteType": "UserUpdateDeviceInfo",
    "kind": "LinkedField",
    "name": "userUpdateDeviceInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedNotificationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sharedNotificationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dcb876cfa0fd8269403eb9105ebf9c3e",
    "id": null,
    "metadata": {},
    "name": "sharedNotificationsMutation",
    "operationKind": "mutation",
    "text": "mutation sharedNotificationsMutation(\n  $deviceIdentifier: String!\n  $devicePlatform: String!\n  $notificationToken: String\n) {\n  userUpdateDeviceInfo(deviceIdentifier: $deviceIdentifier, devicePlatform: $devicePlatform, notificationToken: $notificationToken) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3096fd4853722011a786e40cd21e337";

export default node;
